import PasswordReset from './PasswordReset'

export default PasswordReset



// WEBPACK FOOTER //
// ./src/views/PasswordReset/index.js